import { useMutation } from '@tanstack/react-query';

import type { Vacancy } from 'clients/AutoCompleteClient/types';
import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { getQuestionnaireConfigurationQueryKey } from 'components/ui/organisms/RJCommunicationHub/useQuestionnaireConfiguration';
import { queryClient } from 'config/queryClient';
import {
  mapJobFormValuesToJobImprovedNestedInput,
  mapJobImprovedGetDetailOutputToJobFormValues,
} from 'shared/legacy/contexts/DialogContext/modals/EnrichVacancyModal/utils/EnrichVacancyModal.mappers';
import { useGetJobImprovedQuery } from 'shared/legacy/hooks/useGetJobImprovedQuery';
import { QueryKey } from 'types/query';

export const useAutoProcessJobPreviewVacancy = () => {
  return useMutation({
    mutationKey: [QueryKey.useAutoProcessJobPreviewVacancy],
    mutationFn: async (vacancy: Vacancy) => {
      if (!vacancy.db_id) {
        throw new Error('Vacancy ID is required');
      }

      const jobImproved = await useGetJobImprovedQuery.fetchQuery(vacancy.db_id);

      if (jobImproved.job_preview) {
        return jobImproved;
      }

      const formData = mapJobImprovedGetDetailOutputToJobFormValues(jobImproved);
      const nestedValues = mapJobFormValuesToJobImprovedNestedInput(formData);

      const {
        data: { job_preview },
      } = await reachoutClient.generateJobPreview(nestedValues);

      const { data } = await reachoutClient.patchJobImproved(vacancy.db_id, { job_preview });

      return data;
    },
    onSuccess: (_, vacancy) => {
      const jobId = Number(vacancy.db_id);
      queryClient.resetQueries([QueryKey.useGetJobImproved, { db_id: jobId }]);
      queryClient.invalidateQueries({ queryKey: getQuestionnaireConfigurationQueryKey(jobId) });
    },
  });
};
